export const SET_FORMS = "setForms";
export const SET_FORMS_TOTAL = "setFormsTotal";
export const SET_FORM = "setForm";
export const SET_LOADING = "setLoading";
export const SET_STAMPS = "setStamps";
export const SET_STAMPS_TOTAL = "setStampsTotal";

export default {
  [SET_FORMS](state, forms) {
    state.forms = forms;
  },
  [SET_FORMS_TOTAL](state, totalCount) {
    state.totalCount = totalCount;
  },
  [SET_FORM](state, form) {
    state.form = form;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [SET_FORMS_TOTAL](state, totalCount) {
    state.totalCount = totalCount;
  },
  [SET_STAMPS](state, forms) {
    state.stamps = forms;
  },
  [SET_STAMPS_TOTAL](state, totalCount) {
    state.stampsTotalCount = totalCount;
  },
};
